const CommonActionTypes = {
    START_CHANGE_ACCOUNT_LABEL: 'START_CHANGE_ACCOUNT_LABEL',
    SUCCESS_CHANGE_ACCOUNT_LABEL: 'SUCCESS_CHANGE_ACCOUNT_LABEL',
    FAILURE_CHANGE_ACCOUNT_LABEL: 'FAILURE_CHANGE_ACCOUNT_LABEL',
    FINISH_CHANGE_ACCOUNT_LABEL: 'FINISH_CHANGE_ACCOUNT_LABEL',
}

export default CommonActionTypes
